import {
    templateRecordState,
    templateState,
    type TemplateStateProperties,
} from '@/domain/template/templateState';
import type { PlanApprovalState } from '@/domain/plan/planApprovalState';

/** Surgical-template 'state' properties as represented on the API */
export type ApiTemplateStateProperties = {
    /** The resource state (as a Uri). */
    state: string;

    /** The record state (as a Uri). */
    record_state: string;

    /** When the template was created. */
    created: string;

    /** When the template was last modified. */
    updated: string;

    /**
     * Whether the plan this template currently points at was approved, or only proposed.
     *
     * Null when the template has no plan yet. A proposed plan is still waiting for a surgeon, so
     * approval stays available even when nothing has changed since it was made.
     */
    current_plan_approval_state: PlanApprovalState | null;
};

/** Convert template state-properties from the API */
export function templateStateProperties(
    properties: ApiTemplateStateProperties,
): TemplateStateProperties {
    const { created, updated } = properties;
    return {
        state: templateState(properties.state),
        recordState: templateRecordState(properties.record_state),
        created,
        updated,
        currentPlanApprovalState: properties.current_plan_approval_state,
    };
}
